import { H3, H5 } from '@components/Typography';
import styled from 'styled-components';

export const SectionRoot = styled.section<{
  padding?: string;
  maxWidth?: string;
}>`
  max-width: ${({ maxWidth }) => maxWidth || '100%'} !important;
  padding: ${({ padding }) => padding || '7rem 6rem'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    padding: 6rem 2rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: ${({ padding }) => padding || 'padding: 6rem 2rem'};
  }
`;

export const TitleWrapper = styled.div`
  margin: 2rem 0rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin: 1rem 0rem;
  }
`;

export const Title = styled(H3)<{ $color?: string }>`
  text-align: center;
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size40};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  overflow-wrap: anywhere;
  word-break: break-word;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size35};
    line-height: ${({ theme }) => theme.lineHeight.height115};
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    text-align: left;
  }
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Subtitle = styled(H5)<{ $color?: string }>`
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size22};
  line-height: ${({ theme }) => theme.lineHeight.height165};

  margin-bottom: 4rem;

  width: 70%;
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    width: 100%;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    font-weight: ${({ theme }) => theme.fontWeight.weight500};
    line-height: ${({ theme }) => theme.lineHeight.height140};
    margin-bottom: 2rem;
    text-align: left;
  }
`;

export const UnderlineContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    justify-content: flex-start;
  }
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 160px;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color || theme.color.white};
`;
